/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useTranslation } from "react-i18next";
import { useLocation } from "wouter";

import { createDealerLink } from "../../navigation/createDealerLink";
import { useIsNationalSite } from "../../stores/hooks/useIsNationalSite";
import { useIsDealerGroup } from "../DealerGroup/useIsDealerGroup";
import { pricingAnalysisHash } from "../PricingAnalysis/PricingAnalysisModal";
import { usePricingAnalysisSetting } from "../PricingAnalysis/usePricingAnalysisSetting";
import { useNationalLink } from "./useNationalLink";

export type HeaderLink =
  | {
      href: string;
      isActive?: never;
      name: string;
      to?: never;
    }
  | {
      href?: never;
      isActive: boolean;
      name: string;
      to: string;
    };

export const useHeaderLinks = (): HeaderLink[] => {
  useLocation();
  const { t } = useTranslation();
  const isNational = useIsNationalSite();
  const isDealerGroup = useIsDealerGroup();
  const pricingAnalysisIsEnabled = usePricingAnalysisSetting();
  return [
    useNationalLink(),
    pricingAnalysisIsEnabled &&
      createDealerLink(t("siteHeader.pricingAnalysis"), pricingAnalysisHash),
    !isNational &&
      !isDealerGroup &&
      createDealerLink(t("siteHeader.contactUs"), "contact-us"),
  ].filter(Boolean) as HeaderLink[];
};
